import { KeyboardEvent, useCallback } from 'react';

type Direction = 'up' | 'down';

type Options = {
  disabled?: boolean;
  onStep: (direction: Direction) => void;
};

export const useStepperKeyboard = ({ disabled, onStep }: Options) =>
  useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (disabled) {
        return;
      }

      if (e.key === 'ArrowUp') {
        e.preventDefault();
        onStep('up');
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        onStep('down');
      }
    },
    [disabled, onStep]
  );
